import { NavLink, useLocation } from 'react-router-dom';
import Brand from './Brand';
import { NAV_ITEMS } from './navItems';
import { useWorkspace } from '../../integrationQA/context/WorkspaceContext';

/** Primary navigation. On < lg screens it behaves as an off-canvas drawer controlled by `open`. */
export default function Sidebar({ open, onClose }) {
  const { can } = useWorkspace();
  const { pathname } = useLocation();
  const items = NAV_ITEMS.filter((item) => !item.permission || can(item.permission));
  return (
    <>
      <aside id="cb-sidebar" className={`cb-sidebar ${open ? 'is-open' : ''}`} aria-label="Primary">
        <div className="px-3 pt-3 pb-4"><Brand /></div>
        <nav>
          <ul className="list-unstyled mb-0 px-2">
            {items.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  onClick={onClose}
                  className={({ isActive }) => `cb-nav-link ${isActive || (item.also || []).some((p) => pathname.startsWith(p)) ? 'active' : ''}`}
                >
                  <i className={`bi ${item.icon}`} aria-hidden="true" />
                  <span>{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </aside>
      {open && <div className="cb-backdrop" onClick={onClose} aria-hidden="true" />}
    </>
  );
}
